import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EdgeAuthenticationApi } from '@trialcard/apigateway.client';
import { UserRequestModel } from '@trialcard/apigateway.models';
import { OnClear } from '~/services/clearModule';
import { Settings } from '~/services/settings';
import SessionModule from '~/store/session';
import CommonTools from '~/components/tools/commonTools';

/* eslint-disable dot-notation */
@InjectModule({ stateFactory: true }, module)
@OnClear<UserModule>(async value => value.clear())
export default class UserModule extends InjectVuexModule {
    @Resolve
    edgeAuthentication!: EdgeAuthenticationApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    session!: SessionModule;

    @Action({ rawError: true })
    async getUsers(body = {} as any) {
        const results = await this.edgeAuthentication
            .userGetUsersByLinkedAccount(this.session.profile!['https://apigateway.trialcard.com/account'])
            .then(data => {
                const userResponse = (data.data.data as UserResponseData[]).map(userData => {
                    return {
                        email: userData.email,
                        firstName: userData.given_name || userData.name,
                        lastName: userData.family_name || '',
                        type: userData.app_metadata.gatewayRoles[0],
                        phoneNumber: CommonTools.auth0StringToPhone(
                            userData.user_metadata && userData.user_metadata.phoneNumber
                                ? userData.user_metadata.phoneNumber
                                : ''),
                        userId: userData.user_id,
                        role: userData.app_metadata.gatewayRoles[0]                    };
                });
                return userResponse;
            })
            .catch(error => {
                throw error;
            });
        return results;
    }

    @Action({ rawError: true })
    async addUser(newUserInfo: UserRequestModel) {
        try {
            await this.edgeAuthentication.userCreateStandardUser(newUserInfo, this.settings.programId);
            return true;
        } catch {
            return false;
        }
    }

    @Action({ rawError: true })
    async addAdmin(newAdminInfo: UserRequestModel) {
        try {
            await this.edgeAuthentication.userCreatePortalAdmin(newAdminInfo, this.settings.programId);
            return true;
        } catch {
            return false;
        }
    }

    @Action({ rawError: true })
    async deleteUser(userId: string) {
        try {
            await this.edgeAuthentication.userDeleteUser(userId, this.settings.programId);
            return true;
        } catch {
            return false;
        }
    }

    @Action({ rawError: true })
    async updateUser(payload: { userId: string; user: any }) {
        await this.edgeAuthentication
            .userUpdateUser(payload.userId, payload.user, this.settings.programId)
            .then(result => {
                return result;
            })
            .catch(error => {
                throw error;
            });
    }

    @Mutation
    clear() {}
}

export interface UserResponseData {
    email: string;
    name: string;
    given_name: string;
    family_name: string;
    nickname: string;
    app_metadata: { gatewayRoles: string[] };
    phoneNumber?: string;
    user_metadata: { phoneNumber: string };
    user_id: string;
}
